import moment from 'moment';

export const filterOptions = [
  'GN2TACB00XHVX4W',
  'GN492TFBG7DATDF',
  'GN03HWNER5MEW45',
  'GNFPAYWC9M394J5',
  'GNDS14ZN19MA8AE',
  'GNBHVT79GEK8PDY',
  'GN0RDNSRNFX8CN5',
  'GNFEPTP0PBTFA68',
];

export const getCurrentCalendarDay = () => {
  // if (moment().isBefore('2022-11-20')) {
  //   return '2022-11-20';
  // } else {
  return moment().format('YYYY-MM-DD');
  // }
};

//Obtiene la opciones del select
export const getFilterOptions = structure => {
  if (!structure) return;

  return filterOptions.map(filter => {
    let option;

    option = structure.find(round => round.id === filter);
    if (option) return { ...option };
  });
};

//SI NO HAY PARTIDOS EL DIA DE HOY BUSCA LA SIGUIENTE FECHA
export const findNextDate = (structure, date) => {
  let nextDate = moment(date)
    .add('days', 1)
    .format('YYYY-MM-DD');
  const jornadas = [];

  for (let round of structure) {
    round.matchScheduledStartSegments.map(date => {
      if (moment(date.timeFrom).format('YYYY-MM-DD') !== nextDate) return;
      jornadas.push(round);
    });
  }

  if (jornadas.length === 0) {
    return findNextDate(structure, nextDate);
  } else {
    return { jornadas, nextDate };
  }
};

//OBTIENE PARTIDOS A PARTIR DE UNA FECHA EN ESPECIFICO
const getMatchesByDate = (jornadas, fromDate) => {
  const options = [];
  for (let filterOption of filterOptions) {
    let option;

    option = { ...jornadas.find(round => round.id === filterOption) };
    if (Object.keys(option).length > 0) {
      option.matchScheduledStartSegments = option.matchScheduledStartSegments.filter(
        date => moment(date.timeFrom).format('YYYY-MM-DD') === fromDate,
      );
      options.push(option);
    }
  }
  return options;
};

//OBTIENE CON EL FILTRO DE TODOS
const getAllJornadas = structure => {
  return filterOptions.map(option => {
    for (let round of structure) {
      if (round.id === option) {
        return round;
      }
    }
  });
};

//Encuentra la jornada segun el filtro seleccionado
export const findJornada = (structure = [], idJornada, setSelectFilter) => {
  if (!idJornada) return;

  //Filtro todos
  if (idJornada === 'all') {
    return {
      jornada: getAllJornadas(structure),
      notFoundResults: false,
      nextDate: '',
    };
  }

  //Filtro hoy
  if (idJornada === 'today') {
    const currentDate = getCurrentCalendarDay();
    const jornadas = [];

    //Obtiene las rondas con la fecha actual
    for (let round of structure) {
      round.matchScheduledStartSegments.map(date => {
        if (moment(date.timeFrom).format('YYYY-MM-DD') !== currentDate) return;
        jornadas.push(round);
      });
    }

    //Regresa las rondas que corresponden al mundial
    if (jornadas.length === 0) {
      setSelectFilter(prev => ({
        textContent: prev?.prevFilter?.textContent,
        id: prev?.prevFilter?.id,
        prevFilter: prev?.prevFilter,
      }));

      return {
        // jornada: getMatchesByDate(nextValues.jornadas, nextValues.nextDate),
        jornada: [],
        notFoundResults: true,
        nextDate: '',
      };
    } else {
      return {
        jornada: getMatchesByDate(jornadas, currentDate),
        notFoundResults: false,
        nextDate: '',
      };
    }
  }

  //Cualquier otro filtro seleccionado
  return {
    jornada: [structure.find(round => round.id === idJornada)],
    notFoundResults: false,
    nextDate: '',
  };
};
